import { render, staticRenderFns } from "./TransferCheckout.vue?vue&type=template&id=4852f1b4"
import script from "./TransferCheckout.vue?vue&type=script&lang=js"
export * from "./TransferCheckout.vue?vue&type=script&lang=js"
import style0 from "./TransferCheckout.vue?vue&type=style&index=0&id=4852f1b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports